<template>
  <div>
    <b-modal id="modal-trainer-view" centered size="lg">
      <b-tabs v-if="current_trainer">
        <b-tab title="Інформація" active>
          <div class="mt-4 position-relative">
            <b-row>
              <b-col class="col-6 mt-3">
                <b-overlay no-center show rounded="sm" opacity="0">
                  <template #overlay>
                    <PhotoModal :client="false" :trainer="current_trainer.id" />
                  </template>
                  <b-card-img
                    id="trainer-pic"
                    class="m-3"
                    :src="picPath"
                  ></b-card-img>
                </b-overlay>
              </b-col>
              <b-col class="ms-3">
                <label class="mb-2">Ім'я</label>
                <b-form-input
                  :disabled="readonlyInputs"
                  v-model="current_trainer.name"
                ></b-form-input>
                <label class="mb-2">Призвіще</label>
                <b-form-input
                  :disabled="readonlyInputs"
                  v-model="current_trainer.surname"
                ></b-form-input>
                <label class="mb-2">Дата народження</label>
                <b-form-input
                  :disabled="readonlyInputs"
                  v-model="current_trainer.birthday"
                ></b-form-input>
                <label class="mb-2">Вид тренування</label>
                <b-form-select
                  :disabled="readonlyInputs"
                  :options="options"
                  class="form-control"
                  v-model="current_trainer.training_type"
                ></b-form-select>
                <b-button
                  v-if="readonlyInputs"
                  size="md"
                  class="mt-4"
                  variant="primary"
                  v-on:click="toggleInputs()"
                  >Редагувати
                  <b-icon class="ms-2" icon="info-circle"></b-icon>
                </b-button>
                <b-button
                  variant="outline-danger"
                  class="mt-4 ms-2"
                  @click="removeTrainer"
                  size="md"
                  >Видалити
                  <b-icon class="ms-2" icon="trash"></b-icon>
                </b-button>
                <b-button
                  v-if="!readonlyInputs"
                  size="md"
                  class="mt-4"
                  variant="success"
                  v-on:click="trainerPatch()"
                  >Зберегти
                  <b-icon class="ms-2" icon="info-circle"></b-icon>
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-tab>
        <b-tab title="Документи"> </b-tab>
      </b-tabs>
    </b-modal>
    <Alert
      :class="this.class"
      v-bind:text="this.AlertText"
      v-bind:activErr="this.activErr"
    ></Alert>
  </div>
</template>

<script>
import PhotoModal from "@/components/modals/PhotoModal";
import Alert from "@/components/Toasts/Alert";
import { mapActions, mapState } from "vuex";
const axios = require("axios");

export default {
  name: "TrainerView",
  components: {
    PhotoModal,
    Alert,
  },
  data: function () {
    return {
      activErr: false,
      class: "",
      AlertText: "",
      readonlyInputs: true,
      options: [
        { value: 1, text: "Персональний тренер" },
        { value: 2, text: "Груповий тренер" },
        { value: 3, text: "Масажист" },
        { value: 4, text: "Інші співробітники" },
      ],
    };
  },
  computed: {
    ...mapState(["current_trainer"]),
    picPath: function () {
      if (!this.current_trainer.photopath) {
        return require("@/assets/img/anonymous-user.jpg");
      } else {
        return `${process.env.VUE_APP_API}/trainers/photo/${this.current_trainer.id}`;
      }
    },
    trainType: function () {
      return this.typeSort(this.current_trainer.training_type);
    },
  },
  methods: {
    ...mapActions(["logOutUser"]),
    toggleInputs() {
      this.readonlyInputs = !this.readonlyInputs;
    },
    async trainerPatch() {
      let payload = {
        trainer_id: this.current_trainer.id,
        name: this.current_trainer.name,
        surname: this.current_trainer.surname,
        birthday: this.current_trainer.birthday,
        training_type: this.current_trainer.training_type,
      };
      let config = {
        headers: {
          Authorization: `Bearer ${this.$cookie.get("access_token")}`,
        },
      };
      await axios
        .put(`${process.env.VUE_APP_API}/trainers/patch`, payload, config)
        .then((response) => {
          console.log(response.data);
          this.showModalCreate("Інформація успішно відредагована!", "green");
          this.toggleInputs();
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          } else {
            this.showModalCreate("Щось пішло не так", "red");
            this.toggleInputs();
          }
        });
    },
    async removeTrainer() {
      let result = confirm(
        `Видалити тренера ${this.current_trainer.name} ${this.current_trainer.surname}?`,
      );
      if (!result) return;
      await this.$api.trainers
        .deleteTrainer(this.current_trainer.id)
        .then(() => {
          window.location.reload();
        });
    },
    showModalCreate(text, color) {
      this.activErr = true;
      this.class = color ? color : "green";
      this.AlertText = text;
      setTimeout(() => {
        this.activErr = false;
      }, 4000);
    },
  },
};
</script>

<style scoped></style>
